module.exports = __webpack_public_path__ + "img/product_advantages_4.fe68e347.png";